// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3CY1e","buttons":"Footer_buttons__3Wco0"};